import jQuery from "jquery";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ErrorMessage from "../components/ErrorMessage";
import { ConditionalBlock } from "../ConditionalBlock";
import Constants from "../Constants";
import images from "../images";
import APIUrls from "../services/APIUrls";
import { getAxiosResponse, handleError, putAxiosResponse } from "../services/authApiRoutes/APImethods";
import { dateConvertToTimeStamp, humanize, transformBlankToNull, utcTimeStamp } from "../services/Util";

export default function ExternalLinks(props) {

    const { t } = useTranslation();
    const translate = t;

    const [showExternalLinks, setShowExternalLinks] = useState(false);
    const [searchContact, setSearchContact] = useState("");
    const [selectedContact, setSelectedContact] = useState({});
    const [contacts, setContacts] = useState([]);
    const [totalContacts, setTotalContacts] = useState(0);
    const [pendingContacts, setPendingContacts] = useState(false);
    const [showTestEmailError, setShowTestEmailError] = useState(false);
    const [testEmailErrorMsg, setTestEmailErrorMsg] = useState("");
    const [currPage, setCurrPage] = useState(1);
    const [showSendingEmail, setShowSendingEmail] = useState(false);
    const [disableSendEmail, setDisableSendEmail] = useState(true);
    const [clearSelection, setClearSelection] = useState(false);
    const [commitingEditsMessage, setCommitingEditsMessage] = useState(false);

    const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
    const userTimeZone = useSelector((reduxStore) => reduxStore.customer_bootstrap_data).value.user?.timeZone;
    const theme = aaaSelected ? "dark" : "";
    var syncStatusTimeout;

    const getContentType = () => {
        return props.targetAssetData.current?.files?.FINAL?.asset?.contentType;
    }

    const getAssetType = () => {
        return props.targetAssetData?.current?.files?.FINAL?.asset?.assetType
    }

    const getEloquaContactList = () => {
        const dateTimestamp = dateConvertToTimeStamp();
        getAxiosResponse(APIUrls.ELOQUA_CONTACT_LIST + `?projectId=${props.projectId}&searchTerm=${searchContact}&page=${currPage}&_=${dateTimestamp}`
        ).then(res => {
            setPendingContacts(false);
            if (res.data.code === 200) {
                setContacts(res.data.data.body.result);
                setTotalContacts(res.data.data.body.resultCount);
            }
        }).catch(err => {
            handleError(err)
        })
    }
    
    useEffect(() => {
        getEloquaContactList();
    }, [searchContact, currPage]);

    useEffect(() => {
        setDisableSendEmail(showSendingEmail);
    }, [showSendingEmail]);

    const handleEscOnExternalLinks = (event) => {
        if (event.key === Constants.ESCAPE) {
          setShowExternalLinks(false)
          jQuery(".clickActive").trigger("focus");
          jQuery('.external-links-btn').removeClass('clickActive')
        }
        if (event.key === Constants.ENTER) {
            setShowExternalLinks(false)
            jQuery(".clickActive").trigger("focus");
            jQuery('.external-links-btn').removeClass('clickActive')
          }
        if (event.key === Constants.TAB && event.shiftKey && event.target.ariaExpanded === 'true') {
            jQuery(".clickActive").trigger("focus");
            jQuery('.external-links-btn').removeClass('clickActive')
            setShowExternalLinks(false)
        }
    }

    const handleModalFocusOnExternalLinks = (event) => {
        if (event.key === Constants.ESCAPE) {
            setShowExternalLinks(false)
            jQuery(".clickActive").trigger("focus");
            jQuery('.external-links-btn').removeClass('clickActive');
        }
        if (jQuery(document.activeElement).is('li:first-child a')) {
          if (event.key === Constants.TAB && event.shiftKey) {
            event.preventDefault();
            setShowExternalLinks(false)
            jQuery(".clickActive").trigger("focus");
            jQuery('.external-links-btn').removeClass('clickActive');
          }
        }
    }

    jQuery(document).on("click",".external-links-btn",function() {
        jQuery(this).addClass('clickActive')
        jQuery(document).mouseup(function(e) {
            var bannerCont = jQuery('.outsideClick');
            if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
                setShowExternalLinks(false);
                props.func(false);
                jQuery('.external-links-btn').removeClass('clickActive')
            }
          });
     });

    const getHumanizedContentType = (contentType) => {
        if(contentType === Constants.MARKETOREST) {
            return humanize(Constants.MARKETO);
        }
        return humanize(contentType);
    }

    const enableEmailFunctionality = () => {
        return getContentType() === Constants.ELOQUA && getAssetType() === "EMAIL";
    }

    const sendTestEmailPopup = () => {
        setTimeout(function(){
            jQuery("#search-contact").trigger('focus');
        }, 1000)   
        jQuery("body").addClass("modal-open-7");
        setShowTestEmailError(false);
        props.func(false);
        setPendingContacts(true);
        setSearchContact(props.currentUserEmail);
        setCurrPage(1);
        setClearSelection(false);
    }

    const onSearchContactSubmit = (event) => {
        setDisableSendEmail(true);
        setPendingContacts(true);
        if (event.target.value.length >= 3 ) {
          setSearchContact(event.target.value);
        } else {
            setPendingContacts(false);
            setContacts([]);
            setTotalContacts(0);
            setShowTestEmailError(false);
        }
    }

    const contactColumns = [
        {
          id: "contact.emailAddress",
          name: translate("icr.label_email"),
          maxWidth: "350px",
          selector: (contact) => contact.emailAddress,
          sortable: true,
          cell: (contact) => contact.emailAddress
        },
        {
          id: "contact.firstName",
          name: translate("icr.label_firstname"),
          maxWidth: "350px",
          selector: (contact) => contact.firstName,
          sortable: true,
          cell: (contact) => contact.firstName
        },
        {
          id: "contact.lastName",
          name: translate("icr.label_lastname"),
          maxWidth: "350px",
          selector: (contact) => contact.lastName,
          sortable: true,
          cell: (contact) => contact.lastName
        }
    ]

    const handlePageChange = (page) => {
        setPendingContacts(true);
        setCurrPage(page);
    }

    const onContactSelect = ({ selectedRows }) => {
        setSelectedContact(selectedRows[0]);
        selectedRows.length !== 0 ? setDisableSendEmail(false) : setDisableSendEmail(true);
    };

    const handleSort = async (column, sortDirection) => {
        jQuery(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
          .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING });
    };

    const noDataFoundComponent = () => {
        return (
          <div role="rowgroup">
          <div role="row" className="no-data-display align-center">
           <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_RECORD_FOUND}</p>
          </div></div>
          </div>
        );
    };

    const cancelSendTestEmailOnKeydown = (event) => {
        if (event.key === Constants.ENTER) {
            jQuery("body").removeClass("modal-open-7");
            jQuery('#send-test-email').trigger('focus')
        }
        if(event.key === Constants.TAB) {
            if(jQuery("#send-email-btn").prop('disabled') === true) {
                jQuery("#search-contact").trigger('focus');
            }
        }
    }

    const cancelSendTestEmail = () => {
        jQuery("body").removeClass("modal-open-7");
        jQuery("#search-contact").val(props.currentUserEmail);
        setTotalContacts(0);
        setClearSelection(true);
    }

    const sendEloquaTestEmails = () => {
        let contactId = selectedContact?.id;
        let externalId = props.targetAssetData?.current?.files?.FINAL?.asset?.externalId;
        getAxiosResponse(APIUrls.ELOQUA_SEND_TEST_EMAIL(props.projectId, externalId, contactId))
        .then((res) => {
            setShowSendingEmail(false);
            if(res.data.data && res.data.data.statusCodeValue === 400) {
                setShowTestEmailError(true);
                props.func(false);
                let errors = res.data.data.body.errors;
                if(errors.sendEmailErrors.includes("emailGroupId")) {
                    setTestEmailErrorMsg(translate("icr.usergroup_error"));
                } else {
                    setTestEmailErrorMsg(translate("icr.error_msg"));
                }
            } else {
                setCommitingEditsMessage(false);
                setShowTestEmailError(false);
                props.func(true);
                cancelSendTestEmail();
            }
        })
        .catch((err) => {
            handleError(err);
        })
    }

    const clearSyncStatusTimeout = () => {
        if(syncStatusTimeout) {
            clearTimeout(syncStatusTimeout);
        }
    }

    const fetchCommitedAssetsSyncStatus = (data) => {
        var onTimeUp = function() {
            let url = APIUrls.PROJECT_TRANSLATED_FILE_SYNC(props.projectId, props.targetAssetData.current?.id);
            if(data.commitTime) {
                url = `${url}?commitTime=${utcTimeStamp(data.commitTime, userTimeZone)}`
            }
            getAxiosResponse(url).then((response) => {
                checkSyncingStatus(response.data.data);
            })  
            .catch((err) => {
                handleError(err);
            })
        };
        syncStatusTimeout = setTimeout(onTimeUp, 7000);
    }

    const checkSyncingStatus = (data) => {
        if(data?.syncPending) {
            if (!data.syncErrorExists) {
                fetchCommitedAssetsSyncStatus(data) 
            } else {
                setCommitingEditsMessage(false);
                clearSyncStatusTimeout();
            }
        } else {
            clearSyncStatusTimeout();
            sendEloquaTestEmails();
        }
    }

    const sendTestEmail = () => {
        setShowSendingEmail(true);
        getAxiosResponse(APIUrls.PROJECT_TRANSLATED_FILE_UNCOMMITTED_TRANSLATION_UNITS(props.targetAssetData.current.id, props.projectId))
        .then((response) => {
            if(response.data.data.length === 0) {
                sendEloquaTestEmails();
            } else {
                putAxiosResponse(APIUrls.PROJECT_TRANSLATED_FILE_COMMIT_EDITS(props.projectId, props.phaseId), transformBlankToNull(props.targetAssetData.current?.files?.FINAL))
                .then(() => { 
                    setCommitingEditsMessage(true);
                    fetchCommitedAssetsSyncStatus(response.data.data);              
                })
            }
        })
        .catch((err) => {
            handleError(err);
        })
    }

    const sendTestEmailOnKeyDown = (event) => {
        if(event.key === Constants.ENTER) {
            sendTestEmail();
        }
        if(event.key === Constants.TAB) {
            jQuery("#search-contact").trigger('focus');
        }
    }

    return (
        <>
        <ConditionalBlock condition={getAssetType() !== "FORM"}>
            <div className="chat-box redirectIcon download-dropdown outsideClick">
                <button aria-label="External Link"
                    onClick={e=>setShowExternalLinks(prev => !prev)}
                    onKeyDown={(e) => handleEscOnExternalLinks(e)}
                    aria-expanded={showExternalLinks ? "true" : "false"}
                    className={getContentType() === Constants.ELOQUA ? "external-links-btn send-test-email-img" : "external-links-btn"}
                    >
                    <ConditionalBlock condition={getContentType() === Constants.ELOQUA}>
                        <img src={images.ELOQUA_EXTERNAL_VIEW_LOGO} alt={translate("icr.view_in_eloqua")} title={translate("icr.view_in_eloqua")}/>
                    </ConditionalBlock>
                    <ConditionalBlock condition={getContentType() === Constants.MARKETOREST}>
                        <img src={images.MARKETO_EXTERNAL_VIEW_LOGO} alt={translate("icr.view_in_marketo")} title={translate("icr.view_in_marketo")}/>
                    </ConditionalBlock>
                </button>
                <div className={showExternalLinks ? "download-display" : "download-display hide"} onKeyDown={(e) => handleModalFocusOnExternalLinks(e)}>
                    <ul>
                        <li>
                            <a href={props.externalAsset?.url} tabIndex={0} target="_blank" title={"View Translation in " + getHumanizedContentType(props.targetAssetData.current?.files?.FINAL?.asset?.contentType)}>                                                                
                                <span>{translate("icr.view_translation")} {getHumanizedContentType(props.targetAssetData.current?.files?.FINAL?.asset?.contentType)}</span>
                            </a>
                        </li>
                        {enableEmailFunctionality() && <li>
                            <a tabIndex={0} id="send-test-email" aria-label={translate("icr.send_email")} title={translate("icr.send_email")} onClick={() => sendTestEmailPopup()}>                                                                
                                <span>{translate("icr.send_email")}</span>
                            </a>
                        </li>}
                    </ul>
                </div>
            </div>
        </ConditionalBlock>

        <div id="modal-open-7" className="lightbox-panel target-lang-popup">
            <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
            <strong>{!commitingEditsMessage ? translate("icr.select_eloqua_contact") : "Syncing edits to Eloqua"}</strong>
            </div>
            <div className="lightbox-content">
            {!commitingEditsMessage ? <><div className="gb-gray-list flex flex-align-center mar-bot16">
                <label className="mr-12" htmlFor="search-contact">{translate("icr.label_search")}</label>
                <input id="search-contact" type="text" className="form-control-sm send-test-email-input mr-12" defaultValue={searchContact} onChange={(e) => onSearchContactSubmit(e)} />
                <ConditionalBlock condition={totalContacts != 0}>
                    <p className="mar-top15">{totalContacts} {translate("icr.contacts_found")}</p>
                </ConditionalBlock> 
                </div>
                <div className="datatable-block">
                    <DataTable 
                        columns={contactColumns}
                        data={contacts}
                        pagination
                        paginationServer
                        paginationTotalRows={totalContacts}
                        paginationPerPage={5}
                        paginationRowsPerPageOptions={[5]}
                        paginationDefaultPage={1}
                        onChangePage={handlePageChange}
                        selectableRows
                        selectableRowsSingle
                        selectableRowsHighlight={true}
                        clearSelectedRows={clearSelection}
                        defaultSortFieldId={1}
                        theme={theme}
                        progressPending={pendingContacts}
                        onSelectedRowsChange={onContactSelect}
                        onSort={handleSort}
                        noDataComponent={noDataFoundComponent()}
                        highlightOnHover
                        responsive
                        striped
                    />
                    </div>
                </> : 
                <p>{Constants.SENDING_EDITS_TO_ELOQUA_MESSAGE}</p>}
            </div>
            <ConditionalBlock condition={showTestEmailError}>
                <ErrorMessage message={testEmailErrorMsg} class="error-alert mar-left22"></ErrorMessage>
            </ConditionalBlock>
            <div className="modal-footer modal-footer-border flex px-22">
                <button className="btn btn-bold" onKeyDown={cancelSendTestEmailOnKeydown} onClick={cancelSendTestEmail}>{translate("icr.label_cancel")}</button>
                <button id="send-email-btn" className="btn btn-bold active" onKeyDown={sendTestEmailOnKeyDown} onClick={sendTestEmail} disabled={disableSendEmail}>{showSendingEmail ? translate("icr.label_sending") : translate("icr.label_send_email")}</button>
            </div>
            </div>	
        </div>
        </>
    )
}